import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { BackgroundImage } from 'src/core/types';

import axios from './axios';

export interface UseCreateBackgroundImageVariables {
  temporary_image: string;
}

export interface UseCreateBackgroundImageData extends BackgroundImage {}

export function useCreateBackgroundImage() {
  return useMutation<
    UseCreateBackgroundImageData,
    AxiosError<UseCreateBackgroundImageData>,
    UseCreateBackgroundImageVariables
  >((variables) => {
    var data = variables;

    return axios
      .post<UseCreateBackgroundImageData>(
        '/posht/picasso/background-images/',
        data,
      )
      .then((res) => res.data);
  });
}
